import { render } from "./UserGroupCreate.vue?vue&type=template&id=039a5880&scoped=true"
import script from "./UserGroupCreate.vue?vue&type=script&lang=js"
export * from "./UserGroupCreate.vue?vue&type=script&lang=js"

import "./UserGroupCreate.vue?vue&type=style&index=0&id=039a5880&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-039a5880"]])

export default __exports__